import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
export const Pin: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><path d="M7.76062 16.2422L3.64062 20.3622" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M13.41 13.4065L16.95 9.86649L17.58 10.4965C18.28 11.1965 19.42 11.3765 20.23 10.7865C21.26 10.0465 21.35 8.59649 20.49 7.73649L16.32 3.56649C15.62 2.86649 14.48 2.68649 13.67 3.27649C12.64 4.01649 12.55 5.46649 13.41 6.32649L14.12 7.03649L10.58 10.5765L8.5 9.8865C7.17 9.4465 5.71 9.78649 4.72 10.7765L3.5 11.9965L11.99 20.4865L13.21 19.2665C14.2 18.2765 14.54 16.8165 14.1 15.4865L13.41 13.4065Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};